import { input } from '@angular/core';
import * as i0 from "@angular/core";
export class AgentLoaderComponent {
    constructor() {
        this.currentLoadingText = input('');
    }
}
AgentLoaderComponent.ɵfac = function AgentLoaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLoaderComponent)(); };
AgentLoaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentLoaderComponent, selectors: [["ycn-agent-loader"]], inputs: { currentLoadingText: [1, "currentLoadingText"] }, decls: 6, vars: 1, consts: [[1, "mb-12", "text-center"], [1, "mt-3", "mb-5"], [1, "loading-steps-title", "public-intro"], [1, "mb-5"], [1, "loader-dots", "loader-dots-large", "loader-dots-jumping", "d-inline-block"]], template: function AgentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.currentLoadingText());
    } }, encapsulation: 2, changeDetection: 0 });
